import { convertToCompatibleType } from 'utility/Convert/convertToCompatibleType';

import { Search } from 'types/Search/form';

export const stringifyObject = <T>(value?: T) => {
    if (!value) {
        return '';
    }
    return JSON.stringify(
        value,
        (_key, value) => convertToCompatibleType(value),
        2
    );
};

export const stringifySearch = (value: Search) => {
    const newSearch: Search = {
        ...value,
        destination: {
            ...value.destination,
            label: undefined,
        },
        pagination: {
            pageCount: 0,
            currentPage: 0,
        },
    };

    return stringifyObject(newSearch);
};
